import { render, staticRenderFns } from "./foodTab.vue?vue&type=template&id=0d141ad4&scoped=true"
import script from "./foodTab.vue?vue&type=script&lang=js"
export * from "./foodTab.vue?vue&type=script&lang=js"
import style0 from "./foodTab.vue?vue&type=style&index=0&id=0d141ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d141ad4",
  null
  
)

export default component.exports